module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUdwTLGxsdfX156enunp6f39/ezs7P///4TelSoAAAAHdFJOUwAsu3Nt6sU0B2xIAAAArUlEQVQoz63RIQ+DMBCG4a8pQTOx6WWmlmQCO7FkGoVlYjnPuN7f35UW2vp9jjdPCSnAP3aqBjSTlHvD8a0YeQh3xXknYDfm59YTuCkIzQ6M15gBQsiE5i0cREEMO1EQQyIBpGA3QtcjGFHSSn+EYeHO0Gfdg5V+8G4x0yOF4QtL3OO8xmDDYaOvDSQEBWlKNGwgTomGDAJx9QUZEpC/F3OMS3XH4ZOf1bp//NkfDCc9o7QN85wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/icons/envelope.png
// module id = 671
// module chunks = 0